document.addEventListener("DOMContentLoaded", function() {

  const textWrapper = document.getElementById('variant-description-wrapper');
  if (!textWrapper) return; // Abbruch, wenn wir nicht auf der Produktseite sind

  // Funktion: Zeige den richtigen Text basierend auf der ID
  function showTextForId(variantId) {
    if (!variantId) return;

    const allTexts = textWrapper.querySelectorAll('.dynamic-variant-text');
    
    allTexts.forEach(div => {
      // Vergleich: Ist die ID im Div gleich der gesuchten ID?
      if (div.dataset.variantId == variantId) {
        div.style.display = 'block';
      } else {
        div.style.display = 'none';
      }
    });
  }

  // Strategie 1: URL Überwachung (Am zuverlässigsten bei Blum)
  // Wir prüfen alle 300ms, ob sich die URL geändert hat
  let currentUrl = location.href;
  setInterval(() => {
    if (location.href !== currentUrl) {
      currentUrl = location.href;
      
      // Neue ID aus der URL extrahieren (?variant=12345)
      const urlParams = new URLSearchParams(window.location.search);
      const newVariantId = urlParams.get('variant');
      
      if (newVariantId) {
        showTextForId(newVariantId);
      }
    }
  }, 300);

  // Strategie 2: Direkter Listener auf die Varianten-Buttons (für sofortiges Feedback)
  // Blum nutzt oft <variant-radios> oder <variant-selects>
  const variantPickers = document.querySelectorAll('variant-radios input, variant-selects select');
  
  variantPickers.forEach(picker => {
    picker.addEventListener('change', function() {
      // Wenn es ein Select-Dropdown ist, nehmen wir den Value
      // Wenn es Radio Buttons sind, müssen wir die ID anders ermitteln
      // Der sicherste Weg in OS 2.0 Themes ist oft, kurz auf das URL Update zu warten
      // oder die Daten aus dem JSON script zu holen.
      
      // Einfacher Trick: Wir geben dem Browser 50ms Zeit, die URL zu ändern, 
      // und triggern dann die Funktion oben via URL Params.
      setTimeout(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const vid = urlParams.get('variant');
        if(vid) showTextForId(vid);
      }, 50);
    });
  });
});